
import { Managers } from './area'
import { DealerModel } from './dealer'

export enum GoodsStatus {
  OFF_SHELVES = 'OFF_SHELVES',
  ON_SHELVES = 'ON_SHELVES'
}

export const GoodsOrderBy: {
  [key: string]: string;
} = {

  updatedAt: 'UPDATED_AT',
  isbn: 'ISBN',
  publishedDate: 'PUBLISHED_DATE',
  subTitle: 'SUB_TITLE',
  title: 'TITLE',
  author: 'AUTHOR',
  press: 'PRESS',
  status: 'STATUS',
  price: 'PRICE',
  createdAt: 'CREATED_AT',
  'managers.createdBy.id': 'CREATOR_ID',
  'managers.modifiedBy.id': 'MODIFIER_ID'
}

export interface Goods {
  author: string;
  createdAt: string;
  dealerRelations: RelationOfGoodAndDealerModel[];
  details: string;
  id: number;
  isbn: string;
  managers: Managers;
  press: string;
  price: number;
  publishedDate: string;
  status: GoodsStatus;
  subTitle: string;
  thumb: string;
  title: string;
  updatedAt: string;
  coverImages: string[];
}
export interface RelationOfGoodAndDealerModel {
  dealer: DealerModel;
  dealerId: number;
  details: string;
  good: Goods;
  goodId: number;
  price: number;
  sharingProportion: number;
}

export interface GoodInput {
  author: string;
  coverImages?: string[];
  details?: string;
  isbn?: string;
  press?: string;
  price?: number;
  publishedDate?: string;
  statusIndex?: number;
  subTitle?: string;
  thumb?: string;
  title?: string;
}
